//import hackathon from "./Events/hacathon.jpeg"
//import armw from "./Events/armw.png"
//import smackdown from "./Events/smackdown.jpg"
//import Bgmi from "./Events/bgmi.jpeg"
//import hackhunt from "./Events/hackhunt.jpeg"
//import rapid from "./Events/rapid.jpeg"
//import valorant from "./Events/valorant.jpeg"
//import bayblade from "./Events/bayblade.jpeg"
import workshop from "./Events/WORKSHOP.png"
import linefollower from "./Events/LINE FOLLOWER.png"
import robowar from "./Events/ROBO WAR.png"
import aiimage from "./Events/aiimage.jpeg"
import dronerace from "./Events/dronerace.jpeg"
import dialogue from "./Events/dialoug.png"
import Paper from "./Events/Paper presentation.jpg"
import Drone_by_simulation from "./Events/Drone Racing by Simulation.jpg"
import Button from "../components/common/Button2/Button";


const fees = "₹250 per head common for all events"

export const eventsData = [
  {
    id: 1,
    image: Paper,
    name: "Paper Presentation",
    description:
    "Participate in our Paper Presentation event and showcase your research skills. Dive into the world of innovation, where ideas come to life through compelling presentations. Share your insights, explore cutting-edge topics, and engage with fellow enthusiasts in this intellectual journey.",
    rules: [
      "Team Composition: Form teams of 2 to 3 members, promoting collaboration and diverse skill sets.",
      "Theme Adherence: Ensure your presentation aligns with the specified theme or challenge announced at the beginning of the event.",
      "Code of Conduct: Respectful and ethical conduct is mandatory. Plagiarism or any form of dishonesty will result in immediate disqualification.",
      "Tool Usage: Participants are encouraged to leverage relevant tools and resources, but adherence to open-source and legal software is mandatory.",
      "Submission Deadline: Presentations must be submitted within the specified time frame. Late submissions will not be considered.",
      "Presentation Guidelines: Prepare a concise presentation outlining the problem, solution, and technology used. Each team will have a limited time for showcasing their project.",
      "Judging Criteria: Presentations will be evaluated based on creativity, technical complexity, innovation, and the practicality of the solution.",
      "Software Limitations: Adhere to any hardware or software limitations specified by the organizers.",
      "Q&A Session: Be prepared for a brief Q&A session with the judges after your presentation.",
      "Team Spirit: Encourage a collaborative and supportive environment. The spirit of sportsmanship is highly valued."
    ],
    prizes: ["Win Exciting Cash Prize","Certificate of Participation"],
    team: "2-3",
    fees: fees,
    contactInfo: [
      "Kishore K N : 9385377397",
      "Arulazhagan A : 9655947261",
    ],
    location: "CNC Block",
    date: "22nd April",
    note: [
      "Teams having a working model of their idea will be considered as a plus point by judging panel.",
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  },
  {
    id: 2,
    image: robowar,
    name: "Robo War",
    description: "ROBOWARS... The ultimate test of engineering excellence, teamwork, strategy, and gaming is here! ESEC brings to you its flagship event, Robowars. Witness the engineers of India build the mightiest monsters! Each team has to come up with a wireless( or wired) controlled robot capable of one-on-one combat.",
    rules: [
      "A robot will be declared immobile if it cannot display linear motion of at least two inches in a time period of 30 seconds.",
    "In case both the robots remain mobile after the end of the round then the winner will be decided subjectively.",
    "A robot that is unsafe, as deemed by the judges, will be disqualified immediately and the opponent robot will be declared as the winner.",
    "Every match will consist of 2 rounds of 2 min each with a time gap in between.",
    "If a robot is thrown out of the arena the round will stop immediately, and the robot still inside the arena will automatically be declared as the winner of that particular round.",
    "Robots cannot win by merely lifting their opponents. Organizers will allow lifting for a maximum of 20 seconds for each lift and then the attacker robot will be instructed to release the opponent. If, after being instructed to do so, the attacker is unable to release, their robot will be penalized. The final decision remains in the hands of the Judges.",
    "If two or more robots become entangled due to any reason and become trapped within another robot, then the competitors should make the timekeeper aware and the fight should be stopped and the robots should be separated by the safest means.",
    "Points will be given on the basis of aggression, damage, control, defense, and strategy.",
    "Read all the Rulse before Registration",
      "For rule book click below button",
      <Button hrefLink="https://drive.google.com/drive/folders/1zRmvMKJEg6Hlx5s7sJJpj-8CfM5vxofs" label="Rule Book" />,
      <br></br>, 
    ],
    
    prizes: ["Win Exciting Cash Prize"],
    team: "4 Players",
    contactInfo: [
      "Sathish Pandi M : 9344203623",
      "Joyal T Jacob : 7094428706",
    ],
    fees: fees,
    location: "Ground",
    date: "22nd April 2024",
    note: "",
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  },
  {
    id: 3,
    image: dronerace,
    name: "Drone Racing",
    description:
      "Join the ultimate test of agility and precision with our thrilling Drone Racing event! Navigate your drone through challenging courses, showcasing your piloting skills and speed against fellow competitors. It's a high-flying spectacle you won't want to miss!",
    rules: [
      "Weight Classes: Register in appropriate weight class.",
      "Single-Elimination: Best-of-three rounds, advancing winners.",
      "Referee's Decisions: Final decisions, follow instructions.",
      "Eligibility: College ID required, sign waiver.",
      "Drone Safety: Ensure drones are flight-worthy and comply with safety regulations.",
      "Fair Play: Respect opponents, no intentional interference.",
      "Attire: Wear suitable attire for outdoor racing.",
      "Health Precautions: Be mindful of surroundings and spectators.",
      "Event Disqualification: Organizers can disqualify for rule violations.",
      "Read all the Rulse before Registration",
      "For rule book click below button",
      <Button hrefLink="https://drive.google.com/drive/folders/1zRmvMKJEg6Hlx5s7sJJpj-8CfM5vxofs" label="Rule Book" />,
      <br></br>,    
    ],
    prizes: ["Win Exciting Cash Prize"],
    team: "2-4",
    fees: fees,
    contactInfo: [
      "Hariharan P: 9047430639",
      "Mariselvam G: 6381670230",
    ],
    location: "ESEC Ground",
    date: "22nd Apirl",
    note: [
      "Safety First: Prioritize safety for yourself and others during the event.",
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  },
  {
    id: 4,
    image: dialogue,
    name: "Dialogue Guessing",
    description:
      "Engage in a fun-filled session of Dialogue Guessing! Test your knowledge of famous movie dialogues and see if you can guess the film they're from. Join us for an entertaining event filled with laughter, excitement, and a little friendly competition!",
    rules: [
      "Participants will be presented with famous dialogues from movies.",
      "Guess the name of the movie the dialogue belongs to.",
      "The participant with the highest number of correct guesses wins.",
      "In case of a tie, a sudden-death round will determine the winner.",
    ],
    prizes: ["Win Exciting Cash Prize"],
    team: "Individuals",
    fees: fees,
    contactInfo: [
      "Mohamed Faaiz M : 6385217935"
    ],
    location: "CNC block",
    date: "22nd April",
    note: [
      "Come prepared to test your movie dialogue knowledge and win exciting prizes!"
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  },
  {
    id: 5,
    image: aiimage,
    name: "AI Image Generator",
    description:
      "Unleash your creativity with the AI Image Generator event! Explore the fascinating world of artificial intelligence as you generate stunning images using cutting-edge AI algorithms. Join us for an innovative and inspiring experience!",
    rules: [
      "Participants will use AI-powered image generation tools.",
      "Create captivating images based on given themes or prompts.",
      "Submit your final images within the specified time frame.",
      "Images will be judged based on creativity, originality, and adherence to the theme.",
    ],
    prizes: ["Exciting Prizes Await!"],
    team: "Individuals",
    fees: fees,
    contactInfo: [
      "Dineshkumar G - 8438001585"
    ],
    location: "CNC block",
    date: "22nd April",
    note: [
      "Get ready to push the boundaries of creativity with AI!"
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  }
  ,
  {
    id: 6,
    name: "Workshop",
    image: workshop,
    description:
      "Embark on a journey into the fascinating world of drone technology with our hands-on workshop. Learn about drone design, construction, programming, and flight dynamics from industry experts. Gain practical skills and insights to develop your own drones for various applications.",
    rules: [
      "Open to all participants interested in drone technology.",
      "Registration is required to attend the workshop.",
      "Follow instructions provided by workshop facilitators.",
      "Engage actively in discussions and activities.",
    ],
    fees: fees,
    contactInfo: [
      "Kirbakaran R - 8072733449",
      "Rahul T - 9994785294"
    ],
    location: "Drone Development Center",
    date: "23rd April",
    team: "Individuals",
    note: [
      "Limited seats available. Register early to secure your spot!"
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  }
  ,
  {
    id: 7,
    image: Drone_by_simulation,
    name: ["Drone Racing by ","simulation"],
    description:
    "Experience the thrill of high-speed aerial racing without leaving the ground! Join our Drone Racing Simulation event where you'll pilot virtual drones through challenging courses filled with twists, turns, and obstacles. Compete against fellow pilots to showcase your agility, precision, and speed in this adrenaline-fueled race to the finish line. Strap in, rev up your engines, and get ready for an electrifying virtual adventure!",
        rules: [
    ],
    prizes: ["Win Exciting Cash Prize"],
    team: "Individuals",
    fees: fees,
    contactInfo: [
      "Tamil Arasu K: 9786868834",
      "Kavin K: 9944780011",
    ],
    location: "Drone Development Center",
    date: "23rd April",
    note: [
      "Respect referee decisions.",
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9",
  },

  {
    id: 8,
    image: linefollower,
    name: "Line Follower",
    description: "Embark on an exhilarating journey through the maze in our Line Follower competition. Sharpen your coding skills and guide your robot along the designated path with precision and speed. Compete against fellow enthusiasts to claim the title of the ultimate maze navigator!",
    rules: [
      "The competition is based on completing the maze in the shortest time possible.",
      "Participants will be given 1 minute and 30 seconds to familiarize themselves with the maze.",
      "Decisions made by the organizing committee regarding penalties or disqualifications shall be final and binding.",
      "Participants must present their ID cards.",
    ],
    prizes: ["Win Exciting Cash Prize"],
    team: "Individuals",
    fees: fees,
    contactInfo: [
      "Gokul Raj M S - 9025624448",
      "Manikandan K - 9150973793"
    ],
    location: "CNC Block",
    date: "23rd April",
    note: [
      "In case of technical difficulties, participants must notify event organizers immediately."
    ],
    link: "https://forms.gle/fxL8kxv5ajbm3qew9"
  }
  ,
    
];
